<template>
  <q-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <q-card class="full-width">
      <q-card-section class="q-pa-sm text-center">
        <div class="text-dark wee-text-weight-bold text-body1">
          {{ t("page.account.change_language") }}
        </div>
      </q-card-section>
      <separator size="2px" />
      <q-card-section class="q-pt-none">
        <div class="text-body2 q-my-sm text-dark">
          {{ t("page.account.which_language") }}
        </div>
        <q-option-group
          v-model="selectedLang"
          :options="localeOptions"
          type="radio"
          color="primary"
        >
          <template #label="scope">
            <div class="row items-center justify-between full-width">
              <div class="col-12 text-weight-medium q-mr-xs text-dark">
                {{ scope.label }}
              </div>
            </div>
          </template>
        </q-option-group>
      </q-card-section>

      <q-card-actions align="center">
        <q-btn
          unelevated
          color="orange"
          class="full-width"
          no-caps
          rounded
          :label="`Continue with ${selectedLangLabel}`"
          @click="applyLanguage"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useLang } from "@/composables/useLang";
import Separator from "@/components/Separator.vue";

interface Props {
  modelValue: boolean;
}

interface Emits {
  (e: "update:modelValue", value: boolean): void;
  (e: "language-changed", language: string): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const { t, availableLocales, onSetLocale } = useLang();
const selectedLang = ref("en");

const localeOptions = computed(() =>
  availableLocales.map(locale => ({
    label: locale.name,
    value: locale.iso,
    flag: locale.flag
  }))
);

const selectedLangLabel = computed(() => {
  const selected = availableLocales.find(loc => loc.iso === selectedLang.value);
  return selected?.name || "English";
});

const applyLanguage = () => {
  onSetLocale(selectedLang.value);
  emit("update:modelValue", false);
};
</script>
